import { get, IResponse, post } from "./api";
import { API } from "../../constants";

export interface ICustomTokenResponse {
  customToken: string;
}

export interface IToken {
  roles: any[];
  token: string;
  uid: string;
  userId: number;
}

export interface IUserInfo {
  userId?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  country?: any;
  phoneNumber?: string;
  size?: any;
  company?: {
    columnHashingSal: string;
    name: string;
    companyId: number;
  };
  password?: string;
}

export const getCustomToken = (
  uid: string,
  email: string,
  name: string,
  roles: string[]
): Promise<IResponse<any>> => {
  return post(
    API.USER_SERVICE.FIREBASE_CUSTOM_TOKEN,
    {
      uid,
      email,
      name,
      roles,
    },
    {
      headers: {
        skip: true,
      },
    }
  );
};

export const verifySharedToken = async (token: string): Promise<IToken> => {
  return new Promise((resolve, reject) => {
    post(
      API.USER_SERVICE.VERIFY_FIREBASE_TOKEN,
      {},
      {
        params: {
          firebasetoken: token,
          productType: "IQ",
        },
        headers: {
          skip: true,
        },
      }
    )
      .then((response: any) => {
        const data: IToken = response.data;
        if (data) {
          return resolve(data);
        }
        return reject(new Error(`Token verification failed: ${JSON.stringify(response)}`));
      })
      .catch((error) => {
        reject(error);
      });
  });
};
/*
export const verifyTokenAndSignin: any = (
  token: string,
  name: string,
  email: string
) => {
  return new Promise(async (resolve, reject) => {
    try {
      const tokenResponseObj: IResponse<any> = await verifySharedToken(token);
      const tokenObj = tokenResponseObj?.data || null;
      if (!tokenObj) throw tokenResponseObj;

      getCustomToken(tokenObj.uid, email, name, tokenObj.roles)
        .then((res) => {
          console.log(res);
          resolve({ customToken: res.data, token: tokenObj });
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};*/

export const getUserInfo = (userId: string | number): Promise<IUserInfo> => {
  return new Promise((resolve, reject) => {
    get(`${API.USER_SERVICE.USER_INFO}/${userId}`)
      .then((response: any) => {
        if (response?.data) {
          return resolve(response.data);
        }
        return reject(response);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};
